import { Box, Stack, Typography } from '@mui/material';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';
import type { NodeOutput } from '../../../types/flow-execution.types';

const JSON_COLLAPSE_DEPTH = 2;

interface Props {
  data: NodeOutput;
}

function GenericNodePanel({ data }: Props) {
  return (
    <Stack spacing={1.5}>
      <Box>
        <Typography variant='caption' color='text.secondary'>
          Input
        </Typography>
        <Box
          sx={{
            mt: 0.5,
            p: 1,
            bgcolor: 'action.hover',
            borderRadius: 1,
            maxHeight: 240,
            overflow: 'auto',
            fontSize: 12,
          }}
        >
          {data.input ? (
            <JsonView src={data.input} collapsed={JSON_COLLAPSE_DEPTH} />
          ) : (
            <Typography variant='caption' color='text.secondary'>
              No input recorded.
            </Typography>
          )}
        </Box>
      </Box>
      <Box>
        <Typography variant='caption' color='text.secondary'>
          Output
        </Typography>
        <Box
          sx={{
            mt: 0.5,
            p: 1,
            bgcolor: 'action.hover',
            borderRadius: 1,
            maxHeight: 320,
            overflow: 'auto',
            fontSize: 12,
          }}
        >
          {data.outputData ? (
            <JsonView src={data.outputData} collapsed={JSON_COLLAPSE_DEPTH} />
          ) : data.output ? (
            <Box component='pre' sx={{ m: 0, whiteSpace: 'pre-wrap' }}>
              {data.output}
            </Box>
          ) : (
            <Typography variant='caption' color='text.secondary'>
              No output recorded.
            </Typography>
          )}
        </Box>
      </Box>
    </Stack>
  );
}

export default GenericNodePanel;
